var _path, _g, _g2, _path2, _path3, _path4, _path5, _g3, _rect, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStateCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Empty state - Empty Cart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Background circle",
    d: "M102.778 178.975C143.36 178.975 176.259 146.117 176.259 105.586C176.259 65.0549 143.36 32.1978 102.778 32.1978C62.1954 32.1978 29.2969 65.0549 29.2969 105.586C29.2969 146.117 62.1954 178.975 102.778 178.975Z",
    fill: "url(#paint0_linear_259_12023)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M145.997 54.0635H71.0149L65.0996 66.9763H140.077L145.997 54.0635Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M108.221 52.1128H59.1777L65.0984 66.9769H114.136L108.221 52.1128Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M146.998 52.1128H120.057L114.137 66.9769H141.077L146.998 52.1128Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M141 67H92V91H141V67Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M114 67H65V91H114V67Z",
    fill: "url(#paint1_linear_259_12023)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Particles"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.462 16.9734C128.526 15.3346 126.788 14.5638 125.581 15.2516C124.374 15.9394 124.154 17.8255 125.09 19.4642C125.117 19.5118 125.145 19.5587 125.174 19.6048C124.559 19.7297 123.981 20.3293 123.755 21.1558C123.464 22.2183 123.864 23.2533 124.648 23.4675C125.432 23.6817 126.304 22.994 126.595 21.9315C126.675 21.639 126.703 21.3485 126.685 21.0767C127.457 21.4993 128.297 21.57 128.971 21.186C129.563 20.8487 129.917 20.2233 130.015 19.4803C130.176 19.5643 130.353 19.6339 130.541 19.6853C131.605 19.9759 132.641 19.5766 132.856 18.7934C133.07 18.0102 132.382 17.1397 131.318 16.8491C130.634 16.6623 129.962 16.7606 129.512 17.0626C129.495 17.0328 129.479 17.0031 129.462 16.9734Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0514 23.394C73.5007 23.9609 72.8073 24.2596 72.1088 24.1526C71.3 24.0287 70.6658 23.3887 70.344 22.4998C70.1944 22.7008 70.006 22.8891 69.7829 23.0521C68.8901 23.7042 67.7793 23.7031 67.302 23.0495C66.8247 22.3959 67.1616 21.3373 68.0544 20.6852C68.7658 20.1655 69.6155 20.0607 70.173 20.3701C70.4758 18.5141 71.8184 17.1812 73.1798 17.3897C74.5238 17.5955 75.3858 19.2267 75.1331 21.0566C75.6685 21.1056 76.2459 21.444 76.6575 22.0073C77.3059 22.8946 77.2973 24.004 76.6383 24.4851C75.9792 24.9661 74.9194 24.6368 74.271 23.7495C74.1867 23.6341 74.1135 23.515 74.0514 23.394Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M71.6559 25.3066C70.5532 29.712 74.1251 38.9684 79.6386 39.7027C89.8404 41.0612 87.9668 29.1456 81.8808 31.385C74.6377 34.0501 81.886 45.4506 91.8106 48.0204",
    stroke: "#DCDCDC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M129.642 24.1976C135.706 35.9835 119.641 48.5662 115.194 50.8974",
    stroke: "#DCDCDC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 1",
    d: "M23.4176 98.9514C23.9357 96.8082 26.9841 96.8082 27.5021 98.9514L27.7756 100.083C27.9607 100.849 28.5591 101.447 29.3254 101.632L30.4478 101.902C32.5926 102.419 32.5926 105.47 30.4478 105.987L29.3254 106.258C28.5591 106.443 27.9607 107.041 27.7756 107.807L27.5021 108.938C26.9841 111.082 23.9357 111.082 23.4176 108.938L23.1442 107.807C22.959 107.041 22.3606 106.443 21.5944 106.258L20.472 105.987C18.3272 105.47 18.3272 102.419 20.472 101.902L21.5944 101.632C22.3606 101.447 22.959 100.849 23.1442 100.083L23.4176 98.9514Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Star 2",
    d: "M170.418 139.449C170.936 137.306 173.984 137.306 174.502 139.449L174.776 140.581C174.961 141.347 175.559 141.945 176.325 142.13L177.448 142.4C179.593 142.918 179.593 145.968 177.448 146.485L176.325 146.756C175.559 146.941 174.961 147.539 174.776 148.305L174.502 149.436C173.984 151.58 170.936 151.58 170.418 149.436L170.144 148.305C169.959 147.539 169.361 146.941 168.594 146.756L167.472 146.485C165.327 145.968 165.327 142.918 167.472 142.4L168.594 142.13C169.361 141.945 169.959 141.347 170.144 140.581L170.418 139.449Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 59 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.793 62.9776C45.3352 62.9776 46.5854 61.729 46.5854 60.1887C46.5854 58.6484 45.3352 57.3998 43.793 57.3998C42.2508 57.3998 41.0006 58.6484 41.0006 60.1887C41.0006 61.729 42.2508 62.9776 43.793 62.9776ZM43.793 65.0693C46.4919 65.0693 48.6797 62.8842 48.6797 60.1887C48.6797 57.4932 46.4919 55.3081 43.793 55.3081C41.0941 55.3081 38.9062 57.4932 38.9062 60.1887C38.9062 62.8842 41.0941 65.0693 43.793 65.0693Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M32.7789 135.738C32.4457 134.433 33.6521 133.257 34.9504 133.621L38.4594 134.606C39.7578 134.97 40.1743 136.602 39.2091 137.543L36.6007 140.085C35.6356 141.026 34.0126 140.57 33.6794 139.265L32.7789 135.738Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3",
    d: "M176.68 115.735C177.988 115.404 179.164 116.61 178.797 117.906L177.807 121.41C177.44 122.706 175.806 123.12 174.865 122.154L172.323 119.546C171.382 118.581 171.84 116.961 173.147 116.629L176.68 115.735Z",
    fill: "#385BF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 60 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.427 56.9904C160.666 56.9904 161.67 55.9873 161.67 54.75C161.67 53.5126 160.666 52.5095 159.427 52.5095C158.188 52.5095 157.183 53.5126 157.183 54.75C157.183 55.9873 158.188 56.9904 159.427 56.9904ZM159.427 58.6708C161.595 58.6708 163.353 56.9154 163.353 54.75C163.353 52.5845 161.595 50.8291 159.427 50.8291C157.259 50.8291 155.501 52.5845 155.501 54.75C155.501 56.9154 157.259 58.6708 159.427 58.6708Z",
    fill: "#385BF8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cart"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.318 142.713C101.318 139.682 103.778 137.224 106.813 137.224H138.701C143.057 137.224 147.222 138.512 150.429 140.866C153.634 143.219 156.178 146.92 156.178 151.513C156.178 156.105 153.635 159.806 150.431 162.161C147.224 164.517 143.059 165.806 138.701 165.806H62.9333C59.8981 165.806 57.4375 163.349 57.4375 160.318C57.4375 157.286 59.8981 154.829 62.9333 154.829H138.701C140.961 154.829 142.787 154.148 143.917 153.318C145.049 152.486 145.187 151.785 145.187 151.513C145.187 151.241 145.05 150.542 143.919 149.711C142.789 148.882 140.963 148.202 138.701 148.202L106.492 147.124C103.457 147.124 101.318 145.744 101.318 142.713Z",
    fill: "#969696"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Cart handle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.336 77.1642C152.059 74.4645 154.509 72.5869 157.307 72.5869H182.304C185.718 72.5869 188.485 75.3505 188.485 78.7596C188.485 82.1686 185.718 84.9322 182.304 84.9322H162.051L154.84 111.851C153.958 115.144 150.569 117.099 147.272 116.218C143.975 115.337 142.017 111.953 142.899 108.66L151.336 77.1642Z",
    fill: "url(#paint2_linear_259_12023)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.6,
    d: "M147.685 89.1401H55.4165C48.5 89.1401 43.3911 94.9993 44.9552 101.129L52.4724 137.181C53.6035 141.608 57.9385 144.748 62.9337 144.748L144.29 150.006L158.168 101.145C161.587 91.1423 154.617 89.1401 147.685 89.1401Z",
    fill: "#969696"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_259_12023",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 89,
    width: 115,
    height: 62
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M147.685 89.1406H55.4165C48.5 89.1406 43.3911 94.9998 44.9552 101.129L52.4724 137.181C53.6035 141.608 57.9385 144.749 62.9337 144.749L144.29 150.007L158.168 101.145C159.732 94.9998 154.617 89.1406 147.685 89.1406Z",
    fill: "url(#paint3_linear_259_12023)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_259_12023)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3009",
    width: 7.68743,
    height: 35.6422,
    rx: 3.84371,
    transform: "matrix(0.999966 0.00824429 -0.0123157 0.999924 108.656 116.829)",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3013",
    opacity: 0.6,
    width: 7.67776,
    height: 135.359,
    rx: 3.83888,
    transform: "matrix(0.00662361 0.999978 -0.999997 0.00256632 175.553 91.2861)",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3011",
    width: 7.68743,
    height: 35.6422,
    rx: 3.84371,
    transform: "matrix(0.999966 0.00824429 -0.0123157 0.999924 130.382 116.922)",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3010",
    width: 7.68743,
    height: 35.6422,
    rx: 3.84371,
    transform: "matrix(0.999966 0.00824429 -0.0123157 0.999924 86.9297 116.735)",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3012",
    width: 7.68743,
    height: 35.6422,
    rx: 3.84371,
    transform: "matrix(0.999966 0.00824429 -0.0123157 0.999924 64.9707 116.735)",
    fill: "#969696"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3012_2",
    x: 40.8281,
    y: 87.9463,
    width: 121.079,
    height: 8.31771,
    rx: 4.15885,
    fill: "url(#paint4_linear_259_12023)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Wheels"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left wheel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M81.2368 184.787C88.6314 184.787 94.626 178.8 94.626 171.414C94.626 164.029 88.6314 158.042 81.2368 158.042C73.8422 158.042 67.8477 164.029 67.8477 171.414C67.8477 178.8 73.8422 184.787 81.2368 184.787Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M80.8672 178.157C84.5822 178.157 87.5938 175.149 87.5938 171.439C87.5938 167.729 84.5822 164.721 80.8672 164.721C77.1522 164.721 74.1406 167.729 74.1406 171.439C74.1406 175.149 77.1522 178.157 80.8672 178.157Z",
    fill: "#EBEBF8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Right wheel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M123.834 184.787C131.229 184.787 137.224 178.8 137.224 171.414C137.224 164.029 131.229 158.042 123.834 158.042C116.44 158.042 110.445 164.029 110.445 171.414C110.445 178.8 116.44 184.787 123.834 184.787Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M123.789 178.157C127.504 178.157 130.516 175.149 130.516 171.439C130.516 167.729 127.504 164.721 123.789 164.721C120.074 164.721 117.062 167.729 117.062 171.439C117.062 175.149 120.074 178.157 123.789 178.157Z",
    fill: "#EBEBF8"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Handglass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Handle",
    d: "M148.006 153.625L157.538 143.13L184.405 167.47L184.404 167.471L185.839 168.77C187.232 170.032 188.066 171.795 188.157 173.671C188.249 175.547 187.59 177.383 186.327 178.774C185.063 180.165 183.298 180.998 181.42 181.09C179.541 181.181 177.703 180.523 176.31 179.262L174.876 177.962L174.873 177.965L148.006 153.625Z",
    fill: "url(#paint5_linear_259_12023)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    filter: "url(#filter0_d_259_12023)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.611 125.755C167.611 147.712 149.789 165.511 127.805 165.511C105.822 165.511 88 147.712 88 125.755C88 103.799 105.822 86 127.805 86C149.789 86 167.611 103.799 167.611 125.755ZM161.505 125.755C161.505 144.343 146.417 159.412 127.805 159.412C109.193 159.412 94.1055 144.343 94.1055 125.755C94.1055 107.167 109.193 92.0977 127.805 92.0977C146.417 92.0977 161.505 107.167 161.505 125.755Z",
    fill: "url(#paint6_linear_259_12023)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Glass",
    filter: "url(#filter1_b_259_12023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.805 159.416C146.417 159.416 161.505 144.347 161.505 125.759C161.505 107.17 146.417 92.1016 127.805 92.1016C109.193 92.1016 94.1055 107.17 94.1055 125.759C94.1055 144.347 109.193 159.416 127.805 159.416Z",
    fill: "url(#paint7_linear_259_12023)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "X",
    filter: "url(#filter2_d_259_12023)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.903 125.76L145.541 116.113C146.443 115.158 146.938 113.89 146.92 112.577C146.901 111.264 146.37 110.01 145.441 109.082C144.511 108.153 143.256 107.624 141.941 107.605C140.627 107.586 139.357 108.08 138.401 108.982L128.742 118.629L119.104 108.982C118.64 108.492 118.083 108.1 117.465 107.828C116.846 107.557 116.18 107.412 115.505 107.403C114.83 107.393 114.159 107.519 113.534 107.773C112.908 108.026 112.34 108.403 111.862 108.88C111.385 109.357 111.008 109.924 110.754 110.549C110.5 111.174 110.374 111.843 110.383 112.518C110.393 113.192 110.538 113.858 110.809 114.475C111.081 115.093 111.474 115.649 111.965 116.113L121.619 125.76L111.965 135.407C111.474 135.87 111.081 136.427 110.809 137.044C110.538 137.662 110.393 138.327 110.383 139.002C110.374 139.676 110.5 140.345 110.754 140.97C111.008 141.595 111.385 142.163 111.862 142.64C112.34 143.117 112.908 143.493 113.534 143.747C114.159 144 114.83 144.126 115.505 144.117C116.18 144.107 116.846 143.962 117.465 143.691C118.083 143.42 118.64 143.028 119.104 142.537L128.763 132.89L138.423 142.537C139.387 143.386 140.64 143.835 141.924 143.794C143.209 143.752 144.43 143.223 145.337 142.314C146.245 141.404 146.771 140.184 146.809 138.9C146.847 137.617 146.393 136.368 145.541 135.407L135.903 125.76Z",
    fill: "#F84B7A"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_259_12023",
    x: 84,
    y: 86,
    width: 87.6113,
    height: 87.5107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_259_12023"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_259_12023",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_259_12023",
    x: 79.1055,
    y: 77.1016,
    width: 97.3994,
    height: 97.3149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_259_12023"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_259_12023",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_259_12023",
    x: 104.383,
    y: 104.402,
    width: 48.5371,
    height: 48.7148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_259_12023"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_259_12023",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_259_12023",
    x1: 102.211,
    y1: 8.30068,
    x2: 103.713,
    y2: 266.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_259_12023",
    x1: 64.9445,
    y1: 72.5389,
    x2: 114.26,
    y2: 73.1926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_259_12023",
    x1: 142.636,
    y1: 82.7052,
    x2: 188.734,
    y2: 83.0178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_259_12023",
    x1: 49.6419,
    y1: 230.907,
    x2: 164.267,
    y2: 227.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_259_12023",
    x1: 46.117,
    y1: 107.32,
    x2: 161.823,
    y2: 80.1396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_259_12023",
    x1: 154.196,
    y1: 159.254,
    x2: 163.804,
    y2: 148.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_259_12023",
    x1: 87.9098,
    y1: 104.35,
    x2: 168.044,
    y2: 104.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_259_12023",
    x1: 127.805,
    y1: 92.1016,
    x2: 161.689,
    y2: 180.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateCart);
export default __webpack_public_path__ + "static/media/empty-state-cart.d297b851fc9b0bfc52efe2e71d94e2c4.svg";
export { ForwardRef as ReactComponent };